// localhost server
export const REACT_APP_API =
  'http://localhost:5000/senior-project-97cfa/asia-southeast1/api';

// hosting server
